export const getTranslations = (item, locale) => {
  const translations = item.translations.find((val) => val.locale === locale);
  return translations || item.translations[0];
};
